import type { NavigationGuard } from 'vue-router'
import { inject } from 'vue'
import { errorHandlerKey, servicesKey } from '@/config/keys.ts'
import { useToast } from 'primevue'
import { routeNames } from '@/router/names.ts'
import { onApiErrorHandler } from '@/helpers/backendErrors.ts'
import i18n from '@/i18n'

export const validateResetPasswordTokenGuard: NavigationGuard = async (to, from, next) => {
    const services = inject(servicesKey)
    const errorHandler = inject(errorHandlerKey)
    const toast = useToast()
    const token = to.params.token || ''

    const showErrorToast = () => {
        toast.add({
            summary: i18n.global.t('Error'),
            detail: i18n.global.t('Invalid password reset token, please reset your password again'),
            life: 6000,
        })
    }

    if (!token) {
        showErrorToast()

        return next({
            name: routeNames.FORGOT_PASSWORD_VIEW_NAME,
        })
    }

    try {
        const isValid = await services!.auth.resetPasswordValidateToken(String(token))

        if (!isValid) {
            showErrorToast()

            return next({
                name: routeNames.FORGOT_PASSWORD_VIEW_NAME,
            })
        }

        return next()
    } catch (err) {
        onApiErrorHandler({
            err,
            toast,
            errorTitle: i18n.global.t('Error'),
            defaultErrorMessage: i18n.global.t('An unexpected error occurred, try again'),
            action: 'validateResetPasswordTokenGuard',
            errorHandler,
        })

        return next({
            name: routeNames.FORGOT_PASSWORD_VIEW_NAME,
        })
    }
}
